export default __webpack_public_path__ + "static/media/YAS0280.34I-27653_-16593_0.0a930b14.jpg";